export default "__VITE_ASSET__FLAAcUkS__"